
(function() {
    /**
     * Dynamic Modal implementation.
     *
     * Uses some options :
     *  - target : the link responsible for creating the modal
     *  - url : the modal's url (otherwise defaults to target's href)
     *
     * Supports forms inside modals : if a form is found, it will be submitted using AJAX.
     *
     * The form response should contain messages, which are immediately displayed. The response (in JSON) may contain :
     *  - redirect : url to another location
     *  - reload : reloads the page
     * A string response will replace the modal content.
     *
     * The AjaxModal triggers events on the target if defined :
     *  - before-load.modal : triggered before the modal is loaded. Can be prevented and be used to add data to request.
     *  - modal-show.modal : triggered before the modal is shown. Can be prevented.
     *  - complete.modal : triggered when the initial AJAX request is complete
     *  - modal-shown.modal : triggered when the modal is shown
     *  - modal-hide.modal : triggered just before the modal is hidden
     *  - modal-hidden.modal : triggered when the modal is hidden
     *  - form-complete.modal : triggered when the AJAX request from the inner form is complete
     *  - form-submit.modal : triggered when the form is submitted
     *  - form-response.modal : triggered when the form request is successful. May prevent the default treatment.
     *  - form-success.modal : triggered when the form request is successful (and do not contain functional errors). May prevent the default treatment.
     *  - redirect-modal.modal : triggered when a form response redirects the modal itself. May prevent the default treatment.
     *  - after-form-success.modal : triggered when processing of a form success response is complete.
     */
    var AjaxModal = function (options) {
        this.modal = $(this.template);
        this.modal.data('ajax-modal', this);
        this.options = $.extend({}, AjaxModal.DEFAULTS);

        this.setOptions(options);

        // Parent modal (jQuery object to .modal)
        this.parent = this.options.parent;

        this.data = this.options.data;

        this.modal.on('show.bs.modal', $.proxy(this.onShow, this));
        this.modal.on('shown.bs.modal', $.proxy(this.onShown, this));
        this.modal.on('hide.bs.modal', $.proxy(this.onHide, this));
        this.modal.on('hidden.bs.modal', $.proxy(this.onHidden, this));

        this.modal.modal(options.static ? {
            // backdrop: 'static',
            keyword: false,
            show: false
        } : {
            show: false
        });

        $(document.body).append(this.modal);
        //
        // // Nested modals support
        // if (this.parent && this.parent.length) {
        //
        //     this.modal.on('show.bs.modal', $.proxy(this.fixNestedModals, this));
        // }
    };

    AjaxModal.DEFAULTS = {
        target: null,
        size: 'xlarge',
        modalClass: null,
        form: true,
        keepAlive: false
    };

    $.extend(AjaxModal.prototype, {
        template: "<div class='modal fade' tabindex='-1' role='dialog'>" +
        "<div class='modal-dialog'>" +
        "<div class='modal-content'>" +
        "</div></div></div>",

        // fixNestedModals: function(event) {
        //     var parent = this.parent.data('bs.modal'),
        //         self = this.modal.data('bs.modal');
        //
        //     var zIndex = parent.$element.css('z-index');
        //
        //     // self
        //     console.log(self.$backdrop);
        // },

        setOptions: function(options) {
            if (this.options.modalClass) {
                this.modal.removeClass(this.options.modalClass)
            }

            this.options = $.extend(this.options, options);
            this.target = this.options.target ? $(this.options.target) : null;

            var dialog = this.modal.find('.modal-dialog');

            dialog.removeClass('modal-lg modal-sm modal-md modal-xl modal-xxl modal-fullpage');
            dialog.closest('.modal').removeClass('fullscreen');
            if (this.options.size === 'large') {
                dialog.addClass('modal-lg')
            } else if (this.options.size === 'small') {
                dialog.addClass('modal-sm')
            } else if (this.options.size === 'xlarge') {
                dialog.addClass('modal-xl')
            } else if (this.options.size === 'xxlarge') {
                dialog.addClass('modal-xxl')
            } else if (this.options.size === 'fullpage') {
                dialog.addClass('modal-fullpage');
                dialog.closest('.modal').addClass('fullscreen');
            } else {
                dialog.addClass('modal-md')
            }

            if (this.options.modalClass) {
                this.modal.addClass(this.options.modalClass)
            }

            if (this.options.content) {
                this.loadResponse(this.options.content)
            }
        },

        getUrl: function () {
            return this.options.url;
        },

        getData: function () {
            return this.data || {};
        },

        load: function () {
            var requestData = this.getData(),
                event = this.triggerArgs('before-load.modal', [ requestData ]);

            if (event && event.isDefaultPrevented()) {
                return;
            }

            $.ajax({
                url: this.getUrl(),
                data: requestData,
                error: $.proxy(this.onError, this),
                complete: $.proxy(this.onLoadComplete, this),
                success: $.proxy(this.loadResponse, this)
            })
        },

        loadResponse: function (response) {
            var modalContent = this.modal.find('.modal-content');
            modalContent.html(response);
            this.loaded = true;

            var form = modalContent.find('form');

            if (this.options.form && form.length) {
                // Enable Ajax submit
                this.enableAjax(form);
            }

            this.show()
        },

        triggerArgs: function(eventName, params) {
            return this.trigger(eventName, {}, params);
        },

        /**
         * Deprecated, use triggerArgs instead
         *
         * @param eventName
         * @param data
         * @param params
         */
        trigger: function(eventName, data, params) {
            data = data || {};

            data.modal = this;
            data.element = this.modal;

            var event = jQuery.Event(eventName, data);
            if (this.target) {
                this.target.trigger(event, params || []);
            }
            this.modal.trigger(event, params || []);

            return event;
        },

        onHide: function (event) {
            var form = this.modal.find('form');

            // Trigger show event
            if (this.triggerArgs('modal-hide.modal', [form]).isDefaultPrevented()) {
                event.preventDefault();
            }
        },

        onShow: function () {
            var form = this.modal.find('form');

            // Trigger show event
            if (this.triggerArgs('modal-show.modal', [form]).isDefaultPrevented()) {
                return
            }

            if (this.options.form && form.length) {
                // Enable Ajax submit
                this.enableAjax(form);
            }
        },

        enableAjax: function(form) {
            var self = this;

            form.ajaxForm({
                dataType: this.options.dataType,
                beforeSerialize: $.proxy(this.onFormSerialize, this),
                success: $.proxy(this.loadFormResponse, this),
                complete: function () {
                    self.onFormComplete(form)
                },
                error: function (xhr) {
                    // if (xhr.status === 400) {
                        // form.formErrors(xhr.responseJSON)
                    // } else {
                        self.onError(xhr)
                    // }
                }
            })
        },

        /**
         * Trigger form-complete event on form.
         *
         * @param form
         */
        onFormComplete: function (form) {
            this.triggerArgs('form-complete.modal', [form]);
        },

        onShown: function () {
            // Give focus to form element
            // Give focus to first form element (non hidden)
            setTimeout($.proxy(this.giveFocus, this), 10);

            this.triggerArgs('modal-shown.modal');
        },

        giveFocus: function () {
            var autofocus = this.modal.find('form [autofocus]');
            if (autofocus.length == 0) {
                autofocus = this.modal.find('form input[type!=hidden], form select, form textarea').first();
            }

            if (undefined === autofocus.attr('data-no-autofocus')) {
                autofocus.first().focus();
            }
        },

        onLoadComplete: function () {
            this.triggerArgs('load-complete.modal');
        },

        onError: function(xhr) {
            // Send error event
            this.triggerArgs('error.modal', [xhr.responseText, xhr])
        },

        onFormSerialize: function (form, options) {
            this.triggerArgs('form-submit.modal', [form, options]);
        },

        onHidden: function () {
            this.triggerArgs('modal-hidden.modal');

            if (!this.keepOnHideFlag && !this.options.keepAlive) {
                // Empties the modal's body when hidden
                this.modal.find('.modal-content').empty();
                this.loaded = false;
            }
        },

        loadFormResponse: function (response) {
            var self = this;

            // Notifications
            Notifications.messages(response.messages);

            // Trigger form-response.modal response
            var event = this.triggerArgs("form-response.modal", [response]);
            if (event.isDefaultPrevented()) {
                return
            }

            // string response are considered html content to replace modal content
            // The modal is hidden (but the backdrop is kept) if the page location has changed or is reloaded
            if (typeof response == 'string') {
                this.loadResponse(response)
            } else {
                // Trigger form-success.modal response
                var eventSuccess = this.triggerArgs("form-success.modal", [response]);
                if (eventSuccess.isDefaultPrevented()) {
                    return
                }

                // Response behavior implementation
                if (response.redirectModal) {
                    // Close the modal then reopen one once it is closed,
                    // otherwise different forms with same ids might exist at the same time.
                    var redirected = new AjaxModal({
                        url: response.redirectModal,
                        size: response.modalSize || self.options.size,
                        modalClass: response.modalClass || self.options.modalClass,
                        target: self.target
                    });

                    if (!self.triggerArgs('redirect-modal.modal', [redirected]).isDefaultPrevented()) {
                        this.one('hidden.bs.modal', function() {
                            redirected.show();
                        }).hide();
                    }
                } else if (response.redirect) {
                    // Redirect to another location
                    window.location = response.redirect;
                    this.makeWindowLoader()
                } else if (response.reload) {
                    // Reload current page
                    window.location.reload();
                    this.makeWindowLoader()
                } else if (response.modalContent) {
                    // Reload new modal
                    this.hide();

                    new AjaxModal({
                        content: response.modalContent,
                        size: response.modalSize,
                        static: response.modalStatic
                    }).show()
                } else if (response.confirmPopup) {
                    this.handleConfirmation(response.confirmPopup);
                } else {
                    // Otherwise, close the modal
                    this.hide()
                }

                // Trigger after-form-success.modal response
                this.triggerArgs("after-form-success.modal", [response]);
            }
        },

        makeWindowLoader: function () {
            //this.modal.modal('hide')
            //$(document.body).addClass('loading')

            // Just disable buttons
            this.modal.find('form').formLoading()
        },

        reload: function(url) {
            if (url) {
                this.options.url = url;
            }

            this.loaded = false;
            this.load();
        },

        show: function () {
            if (this.loaded) {
                this.modal.modal('show')
            } else {
                this.load()
            }

            return this
        },

        hide: function () {
            this.modal.modal('hide');

            return this
        },

        hideAndKeep: function () {
            this.keepOnHideFlag = true;
            this.modal.modal('hide');

            return this
        },

        handleConfirmation: function(confirmPopup) {
            this.hideAndKeep();
            var self = this;

            var popup = new AjaxModal({
                content: confirmPopup,
                static: true
            });
            var confirmed = false;

            popup.modal.on('shown.bs.modal', function(event) {
                $(event.currentTarget).find('[data-confirm]').on('click', function(event) {
                    confirmed = true;

                    // Append hidden confirmation field
                    var form = self.modal.find('form'),
                        confirmSelector = $(event.currentTarget).attr('data-confirm'),
                        confirmField = form.find(confirmSelector);

                    if (confirmField.length == 0) {
                        throw "Missing confirmation field " + $(event.target).attr('data-confirm');
                    }

                    confirmField.val(1);
                    form.submit();

                    popup.hide();
                });
            });
            popup.modal.on('hidden.bs.modal', function() {
                if (!confirmed) {
                    self.show();
                }
            });
        },

        /**
         * Proxy for finding inner elements
         * @param selector
         */
        find: function (selector) {
            return this.modal.find(selector)
        },

        on: function(event, callback) {
            this.modal.on(event, callback);

            return this;
        },

        one: function(event, callback) {
            this.modal.one(event, callback);

            return this;
        }
    });

    // Modal plugin
    var ModalPlugin = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function (index, element) {
            var target = $(element),
                modal = target.data('ajax-modal');

            if (typeof options == 'string') {
                if (!modal) {
                    return;
                }

                modal[options].apply(modal, args);
            }

            if (typeof options == 'object' && modal) {
                modal.setOptions(options);
            }

            if (!modal) {
                options = (typeof options == 'object' && options) || {};

                modal = new AjaxModal(options);
                target.data('ajax-modal', modal)
            }

            if (typeof options != 'string') {
                modal.show();
            }
        })
    };

    // Modal data API
    $(document).on('click.modal', '[data-toggle=ajax-modal]', function (event) {
        event.preventDefault();

        var target = $(event.currentTarget);

        target.ajaxModal({
            url: target.attr('href') || target.attr('data-href'),
            size: target.attr('data-size'),
            modalClass: target.attr('data-modal-class'),
            content: target.attr('data-modal-content'),
            dataType: target.attr('data-form-data-type'),
            target: target,
            parent: target.closest('.modal')
        })
    });

    // Export Modal
    $.fn.ajaxModal = ModalPlugin;
    $.fn.ajaxModal.Constructor = AjaxModal;

})(jQuery);


// WEBPACK FOOTER //
// ./js/modal.js